/**
 * API Keys Settings Page
 * Placeholder — full implementation from original will be ported.
 */

export function ApiKeysSettingsPage() {
  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-text-primary">API Keys</h2>
      <div className="rounded-lg border border-border-default bg-bg-secondary p-6">
        <p className="text-text-secondary">
          API key management interface will be displayed here.
        </p>
      </div>
    </div>
  );
}
